let domain = ''
let weakup_host = ''
let socket = ''

if (/release-science.docbook.com.cn/.test(window.location.href) || /localhost/.test(window.location.href)) {
	domain = 'https://mapirelease.docbook.com.cn'
	weakup_host = 'https://releasestatic.docbook.com.cn'
	socket = 'wss://testsocket.docbook.com.cn:8443'
} else if (/test-science.docbook.com.cn/.test(window.location.href)) {
	domain = 'https://mapitest.docbook.com.cn'
	weakup_host = 'https://releasestatic.docbook.com.cn'
	socket = 'wss://testsocket.docbook.com.cn:8443'
} else {
	domain = 'https://mapi.docbook.com.cn'
	weakup_host = 'https://static.docbook.com.cn'
	socket = 'wss://chatsocket.docbook.com.cn:8443'
}
// https://test-science.docbook.com.cn/

export default {
	testUrl: domain,
	domain,
	weakup_host,
	socket
}